module.exports = __webpack_public_path__ + "static/simcrest-apps-auto-email-92440c7ab269ec8fb275fcdc70f27374.png";